import { useRouter } from "@tanstack/react-router"

import { PopUpNotification } from "@/components/others/notification"
import { AiFloatButton } from "@/components/shared/global/ai-float-button"
import { BgLinearTop } from "@/components/shared/icons/background"
import { Logo } from "@/components/shared/layout/logo"
import { useLayoutStore, useNavigationLeft } from "@/modules/helpers/hooks/shared"
import { sendHaptic } from "@/modules/helpers/utils"

export const Header = () => {
  const { setOpen } = useNavigationLeft()
  const { insetTop } = useLayoutStore()
  const router = useRouter()
  return (
    <>
      <div className="absolute z-0 -top-20 left-0 w-full">
        <BgLinearTop />
      </div>
      <header
        className="w-full z-10  px-3 py-4 flex items-center justify-between"
        style={{
          paddingTop: `${insetTop + 10}px`
        }}
      >
        <div
          className="flex items-center gap-3 h-10"
          onClick={() => {
            setOpen(true)
            sendHaptic()
          }}
        >
          <Logo />
        </div>
        <div className="flex items-center gap-3 justify-center h-full">
          <div
            data-tour="ai-button"
            className="w-9 h-9 rounded-full border border-primary-100 bg-white flex justify-center items-center"
          >
            <AiFloatButton />
          </div>
          <div
            data-tour="blog-button"
            className="w-9 h-9 rounded-full border border-gray-200 bg-white flex justify-center items-center relative"
            onClick={() => {
              router.navigate({ to: "/blog" })
            }}
          >
            <p className="text-xss font-normal text-primary">Blog</p>
            <span className="absolute right-0.5 top-0.5 h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />
          </div>
          <div
            data-tour="notification-button"
            className="w-9 h-9 rounded-full border border-primary-100 bg-white flex justify-center items-center"
          >
            <PopUpNotification />
          </div>
        </div>
      </header>
    </>
  )
}
